import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { environment } from '../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class UserOtpVerificationService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  // Email Verify OTP
  async emailOtpVerification(email: string, otp: string) {
    const API_URL: string = environment.baseUrl + environment.apis.verifyEmailOtp;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'username': email,
        'otpcode': otp
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  // Resend Email OTP
  async resendEmailOtp(email: string) {
    const API_URL: string = environment.baseUrl + environment.apis.resendEmailOtp;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        'username': email
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }
  
}
